var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-progress',{staticClass:"w-100",attrs:{"height":_vm.height}},[_c('b-progress-bar',{style:(`background-color: ${_vm.defaultColorProgress}`),attrs:{"value":_vm.value,"max":_vm.max}},[_c('span',{style:(`color: ${_vm.defaultLabelColor}`)},[_vm._v(_vm._s(_vm.defaultLabel))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }